import { render, staticRenderFns } from "./optionGoodsSearch.vue?vue&type=template&id=a6c97b2e"
import script from "./optionGoodsSearch.vue?vue&type=script&lang=js"
export * from "./optionGoodsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports